class BcosPickupAvailability extends HTMLElement {
  connectedCallback() {
    this.updateAvailability();
  }

  async updateAvailability() {
    const wrapper = this.querySelector('[data-pickup-availability-wrapper]');
    if (!wrapper) return;
    const variantId = this.dataset.variantId;
    if (!variantId) return;
    try {
      const url = `${this.dataset.baseUrl}/variants/${variantId}/pickup_availability?section_id=pickup-availability`;
      const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) return;
      const html = await res.text();
      const template = document.createElement('template');
      template.innerHTML = html.trim();
      const fresh = template.content.querySelector('[data-pickup-availability-wrapper]');
      if (fresh) wrapper.replaceWith(fresh);
    } catch (error) {
      // Optional enhancement; never block the buy box when pickup data is unavailable.
    }
  }
}

if (customElements.get('bcos-pickup-availability') === undefined) {
  customElements.define('bcos-pickup-availability', BcosPickupAvailability);
}
